import React, { useState, useEffect } from "react";
import Axios from "axios";
import swal from "sweetalert";
import "./DispatchChallan.css";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const DispatchChallan = () => {
  const location = useLocation();
  const { form, isEditing } = location.state || {};
  const [partyName, setPartyName] = useState("");
  const [pressName, setPressName] = useState("");
  const [ChaFile, setChaFile] = useState();
  const [ChallanNumber, setChallanNumber] = useState("");
  const [Data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [selectedOrder, setselectedOrder] = useState();
  const [selectedSKUsOptions, setSelectedSKUsOptions] = useState([]);
  const [distributor, setDistributor] = useState([]);
  const [selectedSKUs, setSelectedSKUs] = useState([
    {
      sku: "",
      title: "",
      medium: "",
      edition: "",
      dispatchquantity: [],
      balance: "",
      dispatchQuantityValue: "",
    },
  ]);

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getOrder").then((response) => {
      setData(response.data);
    });
    Axios.get(
      "https://nodei.ssccglpinnacle.com/getCreatesuperdistributor"
    ).then((response) => {
      setDistributor(response.data);
    });
    Axios.get("https://nodei.ssccglpinnacle.com/getPress").then((response) => {
      setList(response.data);
    });
  }, []);

  useEffect(() => {
    if (isEditing && form) {
      setselectedOrder(form.selectedOrder);
      setPartyName(form.partyName);
      setPressName(form.pressName);
      setChallanNumber(form.ChallanNumber);
      if (form.ChaFile) setChaFile(form.ChaFile);
      setSelectedSKUs(form.selectedSKUs);
    }
  }, [isEditing, form]);

  useEffect(() => {
    const selectedOrderObj = filteredOrders.find(
      (order) => order.orderid === (selectedOrder && selectedOrder.value)
    );
    const updatedQuantity = selectedOrderObj
      ? selectedOrderObj.updatedQuantity
      : [];
    const skuOptions = updatedQuantity.map((quantityObj) => ({
      value: quantityObj.sku,
      label: quantityObj.sku,
    }));
    setSelectedSKUsOptions(skuOptions);
    setSelectedSKUs([]);
    renderSKUFields();
  }, [selectedOrder]);

  const handleSKUChange = (selectedOption, index) => {
    const updatedSelectedSKUs = [...selectedSKUs];
    const selectedSKU = updatedSelectedSKUs[index];

    if (selectedSKU) {
      const orderData = filteredOrders.find(
        (order) => order.orderid === selectedOrder.value
      );
      const skuData = orderData.updatedQuantity.find(
        (item) => item.sku === selectedOption.value
      );

      if (skuData) {
        updatedSelectedSKUs[index] = {
          ...selectedSKU,
          sku: selectedOption.value,
          title: skuData.title,
          medium: skuData.Medium,
          edition: skuData.edition,
          dispatchquantity: skuData.newQuantity || [],
          balance: skuData.Balance,
        };
        setSelectedSKUs(updatedSelectedSKUs);
      }
    }
  };

  const handleDispatchQuantityChange = (e, index) => {
    const { value } = e.target;
    const updatedSelectedSKUs = [...selectedSKUs];
    const selectedSKU = updatedSelectedSKUs[index];

    if (value === "custom") {
      const customDispatchQuantity = prompt("Enter custom dispatch quantity:");
      updatedSelectedSKUs[index] = {
        ...selectedSKU,
        dispatchQuantityValue: customDispatchQuantity,
      };
    } else {
      updatedSelectedSKUs[index] = {
        ...selectedSKU,
        dispatchQuantityValue: value,
      };
    }

    setSelectedSKUs(updatedSelectedSKUs);
  };

  const addSKUField = () => {
    setSelectedSKUs([
      ...selectedSKUs,
      {
        sku: "",
        title: "",
        medium: "",
        edition: "",
        dispatchquantity: [],
        balance: "",
      },
    ]);
  };

  const filteredOrders = Data.filter((order) => order.ApprovalDate !== null);

  const orderOptions = filteredOrders.map((order) => ({
    value: order.orderid,
    label: order.orderid,
  }));

  const handleDistributorChange = (selectedOption) => {
    const selectedDistributor = distributor.find(
      (dist) => dist.dname === selectedOption.value
    );
    if (selectedDistributor) {
      setPartyName(selectedDistributor.dname);
    }
  };
  const distributorOptions = [
    ...distributor.map((dist) => ({
      value: dist.dname,
      label: dist.dname,
    })),
  ];

  const handlePressChange = (selectedOptio) => {
    const selectedPress = list.find(
      (dist) => dist.Pressname === selectedOptio.value
    );
    if (selectedPress) {
      setPressName(selectedPress.Pressname);
    }
  };

  const renderSKUFields = () => {
    return selectedSKUs.map((selectedSKU, index) => (
      <div key={index}>
        <label>
          Select SKU :
          <Select
            name="sku"
            options={selectedSKUsOptions}
            value={
              selectedSKU
                ? { value: selectedSKU.sku, label: selectedSKU.sku }
                : null
            }
            onChange={(selectedOption) =>
              handleSKUChange(selectedOption, index)
            }
            placeholder="Select SKU"
          />
        </label>
        <div>Title: {selectedSKU?.title || ""}</div>
        <div>Medium: {selectedSKU?.medium || ""}</div>
        <div>Edition: {selectedSKU?.edition || ""}</div>
        <div>
          Dispatch Quantity:{"   "}
          <select
            value={selectedSKU.dispatchQuantityValue}
            onChange={(e) => handleDispatchQuantityChange(e, index)}
          >
            <option value="">Select</option>
            {(selectedSKU.dispatchquantity || []).map((qtyObj, qtyIndex) => (
              <option key={qtyIndex} value={JSON.stringify(qtyObj)}>
                {qtyObj}
              </option>
            ))}
          </select>
        </div>

        <div>Balance: {selectedSKU?.balance || ""}</div>
      </div>
    ));
  };

  const handleButtonClic = async (event) => {
    event.preventDefault();
    const OrderNo = selectedOrder
      ? parseInt(selectedOrder.value, 10)
      : form?.OrderNo || 0;

    try {
      if (isEditing && form) {
        const formData = new FormData();
        formData.append("OrderNo", OrderNo);
        formData.append("partyName", partyName);
        formData.append("ChallanNumber", ChallanNumber);
        formData.append("pressName", pressName);
        formData.append("ChaFile", ChaFile);

        selectedSKUs.forEach((selectedSKU, index) => {
          formData.append(
            `selectedSKUs[${index}][title]`,
            selectedSKU.title || ""
          );
          formData.append(
            `selectedSKUs[${index}][medium]`,
            selectedSKU.medium || ""
          );
          formData.append(
            `selectedSKUs[${index}][edition]`,
            selectedSKU.edition || ""
          );
          formData.append(
            `selectedSKUs[${index}][dispatchQuantityValue]`,
            selectedSKU.dispatchQuantityValue || ""
          );
          formData.append(`selectedSKUs[${index}][sku]`, selectedSKU.sku || "");
          formData.append(
            `selectedSKUs[${index}][balance]`,
            selectedSKU.balance || ""
          );
        });

        const response = await Axios.put(
          `https://nodei.ssccglpinnacle.com/EditChallanVendor/${form._id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Challan updated:", response.data);
      } else {
        const formData = new FormData();
        formData.append("OrderNo", OrderNo);
        formData.append("partyName", partyName);
        formData.append("ChallanNumber", ChallanNumber);
        formData.append("pressName", pressName);
        formData.append("ChaFile", ChaFile);

        selectedSKUs.forEach((selectedSKU, index) => {
          formData.append(
            `selectedSKUs[${index}][title]`,
            selectedSKU.title || ""
          );
          formData.append(
            `selectedSKUs[${index}][medium]`,
            selectedSKU.medium || ""
          );
          formData.append(
            `selectedSKUs[${index}][edition]`,
            selectedSKU.edition || ""
          );
          formData.append(
            `selectedSKUs[${index}][dispatchQuantityValue]`,
            selectedSKU.dispatchQuantityValue || ""
          );
          formData.append(`selectedSKUs[${index}][sku]`, selectedSKU.sku || "");
          formData.append(
            `selectedSKUs[${index}][balance]`,
            selectedSKU.balance || ""
          );
        });

        const response = await Axios.post(
          "https://nodei.ssccglpinnacle.com/PostChallanVendor",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Challan created:", response.data);
      }
    } catch (error) {
      console.error("Error creating/updating Challan:", error);
    }

    swal({
      title: isEditing ? "Challan Updated" : "Challan Created",
      text: "",
      icon: "success",
    }).then(() => {
      window.location.href = "/ManageChallan";
    });
  };

  const removeLastSKUField = () => {
    if (selectedSKUs.length > 0) {
      const updatedSelectedSKUs = [...selectedSKUs];
      updatedSelectedSKUs.pop();
      setSelectedSKUs(updatedSelectedSKUs);
    }
  };

  return (
    <div className="Challanlabel">
      <h2 style={{ textAlign: "center" }}>Dispatch & Challan</h2>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxWidth: "500px",
          margin: "auto",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          background: "#f9f9f9",
        }}
      >
        <label
          style={{
            display: "flex",
            flexDirection: "column",
            fontWeight: "bold",
          }}
        >
          Printing Press Name:
          <Select
            options={list.map((dist) => ({
              value: dist.Pressname,
              label: dist.Pressname,
            }))}
            value={pressName ? { value: pressName, label: pressName } : null}
            onChange={(selectedOptio) => handlePressChange(selectedOptio)}
            styles={{ container: (base) => ({ ...base, marginTop: "6px" }) }}
          />
        </label>

        {!isEditing && (
          <>
            <label
              style={{
                display: "flex",
                flexDirection: "column",
                fontWeight: "bold",
              }}
            >
              Order No :
              <Select
                name="orderno"
                options={orderOptions}
                value={selectedOrder}
                onChange={(selectedOption) => setselectedOrder(selectedOption)}
                styles={{
                  container: (base) => ({ ...base, marginTop: "6px" }),
                }}
              />
            </label>

            <div>{renderSKUFields()}</div>

            <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
              <button
                type="button"
                onClick={addSKUField}
                style={{
                  padding: "6px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Select SKU ➕
              </button>
              <button
                type="button"
                onClick={removeLastSKUField}
                style={{
                  padding: "6px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                ➖
              </button>
            </div>
          </>
        )}

        <label
          style={{
            display: "flex",
            flexDirection: "column",
            fontWeight: "bold",
          }}
        >
          Party Name:
          <Select
            options={distributorOptions}
            value={partyName ? { value: partyName, label: partyName } : null}
            onChange={(selectedOption) =>
              handleDistributorChange(selectedOption)
            }
            styles={{ container: (base) => ({ ...base, marginTop: "6px" }) }}
          />
        </label>

        <label
          style={{
            display: "flex",
            flexDirection: "column",
            fontWeight: "bold",
          }}
        >
          Challan Number:
          <input
            id="deliverynot"
            type="text"
            value={ChallanNumber}
            onChange={(e) => setChallanNumber(e.target.value)}
            style={{
              marginTop: "6px",
              padding: "6px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
        </label>

        <label
          style={{
            display: "flex",
            flexDirection: "column",
            fontWeight: "bold",
          }}
        >
          Upload Challan:
          <input
            id="filerChal"
            type="file"
            name="file"
            onChange={(e) => setChaFile(e.target.files[0])}
            style={{ marginTop: "6px" }}
          />
        </label>

        <button
          type="button"
          onClick={handleButtonClic}
          style={{
            padding: "8px 14px",
            borderRadius: "6px",
            cursor: "pointer",
            background: "#4CAF50",
            color: "#fff",
            fontWeight: "bold",
            border: "none",
            marginTop: "10px",
          }}
        >
          {isEditing ? "Update Challan" : "Submit Challan"}
        </button>
      </form>
    </div>
  );
};
export default DispatchChallan;
